import { ChevronLeft, ChevronRight } from "lucide-react";

import { Button } from "../ds";
import type { TvFramePageInfo } from "./TvFrame";
import { isHeaderPage, navigationHeaderPage } from "../runtime/pageNavigation";

/** Page navigation for embedded reports: chips for short reports, a grouped
 * dropdown with previous/next for long ones (e.g. 46-page MOP Performance). */
export function PagePicker({ pages: allPages, value: activeValue, onChange }: { pages: TvFramePageInfo[]; value: string | null; onChange: (id: string) => void }) {
  const pages = allPages.filter((page) => isHeaderPage(allPages, page));
  const value = navigationHeaderPage(allPages, activeValue ?? "");
  if (pages.length <= 1) return null;
  const idx = Math.max(0, pages.findIndex((p) => p.id === value));
  if (pages.length <= 8) {
    return (
      <div className="ds-row" style={{ flexWrap: "wrap", gap: 6 }}>
        {pages.map((p) => (
          <Button key={p.id} size="sm" variant={p.id === value ? "primary" : "subtle"} onClick={() => onChange(p.id)}>
            {p.name}
          </Button>
        ))}
      </div>
    );
  }
  const sections: Array<[string, TvFramePageInfo[]]> = [];
  for (const p of pages) {
    const key = p.section || "";
    const last = sections[sections.length - 1];
    if (last && last[0] === key) last[1].push(p);
    else sections.push([key, [p]]);
  }
  return (
    <div className="ds-row" style={{ gap: 6 }}>
      <Button size="sm" icon={ChevronLeft} aria-label="Previous page" disabled={idx === 0} onClick={() => onChange(pages[idx - 1].id)} />
      <select className="ds-select ds-select--sm" style={{ width: "auto", minWidth: 280 }} value={value ?? ""} onChange={(e) => onChange(e.target.value)} aria-label="Page">
        {sections.map(([sec, ps]) =>
          sec ? (
            <optgroup key={sec} label={sec}>
              {ps.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
            </optgroup>
          ) : (
            ps.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)
          ),
        )}
      </select>
      <Button size="sm" icon={ChevronRight} aria-label="Next page" disabled={idx === pages.length - 1} onClick={() => onChange(pages[idx + 1].id)} />
      <span className="ds-small ds-faint">Page {idx + 1} of {pages.length}</span>
    </div>
  );
}
